skrilla.controller('incomeAccessReportDetailsCtrl', function ($scope, $stateParams, searchService, srefService) {

    $scope.showTable = false;

    searchService.get(`affiliates/incomeAccessReports/${$stateParams.id}`, null, true).then(function(response){
        $scope.report = response.data;
        $scope.showTable = response.data.entries.length < 500;
        buildTableForEntries();
    })

    function buildTableForEntries(){
        $scope.tableData = {
            columns: [
                {title: "User Id", field: "userId"},
                {title: "BTag", field: "btag"},
                {title: "Username", field: "username"},
                {title: "Country", field: "country"},
                {title: "User Created At", field: "userCreatedAt", filter:{name: 'dateTimeFormatter'}},
            ],
            rows: {style: "cursor: pointer;", onClick: (user, event) => {srefService.go("userDetails", {id: user.userId}, event)}},
            isSkrillaTable: true,
            data: $scope.report.entries
        }
    }


    $scope.showTableFn = function() {
        $scope.showTable = confirm("Are you sure you want to render this table? It could take a long time")
    }

});
